module.exports = __webpack_public_path__ + "static/ma-3-ad0961905a4678129085c52b2088d0da.png";